module.exports = __webpack_public_path__ + "img/appLanding.789f6022.jpg";